const newStandardPageIds = [
    'mentorSelect',
    'standardSelect'
  ];
  
  newStandardPageIds.forEach(id => {
    $('#' + id).selectize();
  });
  